import { Route, Routes } from 'react-router-dom';

import BillList from '../components/Bills/BillList';
import EditBill from '../components/Bills/EditBill';
import ViewBill from '../components/Bills/ViewBill';

const Bills = () => {
  return (
    <Routes>
      <Route path="/" element={<BillList />} />
      <Route path="/edit/:id" element={<EditBill key="edit" />} />
      <Route path="/edit" element={<EditBill key="add" />} />
      <Route path="/view/:id" element={<ViewBill />} />
    </Routes>
  )
}

export default Bills;